import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";

import SupportSection from "pages/Home/sections/SupportSection";

// Material Kit 2 React examples
import Navbar from "components/Navbars";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections

import HeroSection from "pages/Home/sections/HeroSection";
import Features from "pages/Home/sections/FeaturesOne";
import PricingSection from "components/sections/PricingSection";
import AppListSection from "components/sections/AppListSection";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

import { useTranslation } from "react-i18next";
import { isAuthenticated } from "utils/auth";

function Presentation() {
  const { t } = useTranslation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 初始化登录状态：access token 有效或 refresh token 仍可续期时视为已登录
  useEffect(() => {
    setIsLoggedIn(isAuthenticated());
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      const el = document.getElementById(id);
      if (el) {
        // 延迟一点点，确保所有 section 都渲染完成再滚动
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, []);

  return (
    <>
      <Navbar
        routes={routes}
        action={{
          type: "internal",
          route: isLoggedIn ? "/userinfo/" : "/signin/",
          label: isLoggedIn ? t("nav.userCenter") : t("nav.login"),
          color: "info",
        }}
        sticky
      />
      <HeroSection isLoggedIn={isLoggedIn} />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Features />
        <AppListSection />
        <PricingSection
          userName=""
          expireAt={null}
          hasEverPurchased={false}
          isLoggedIn={isLoggedIn}
        />
        <SupportSection />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
